import { useQuery } from '@apollo/client';
// Api
import { GET_ARTICLES } from 'api/articles/queries';
// Types
import {
  GetArticleForStore,
  GetArticleForStoreVariables,
} from 'api/articles/types/GetArticleForStore';
import {
  ArticleStatus,
  ArticleStoreOrderBy,
  SortDirection,
} from 'api/graphql-global-types';
// Ui
import ContentCard, { ContentType } from 'ui3/Card/ContentCard';
import styles from './ArticleMoreFrom.module.scss';

type ArticleMoreFromProps = {
  storeSlug: string;
  storeName: string;
  currentArticleId: string;
};

export const MORE_FROM_LIMIT = 3;

// One extra row covers the article being read, which the list leaves out.
const ArticleMoreFrom = ({
  storeSlug,
  storeName,
  currentArticleId,
}: ArticleMoreFromProps): JSX.Element | null => {
  const { data } = useQuery<GetArticleForStore, GetArticleForStoreVariables>(
    GET_ARTICLES,
    {
      variables: {
        input: {
          storeSlug,
          statuses: [ArticleStatus.Active],
          orderBy: ArticleStoreOrderBy.createdAt,
          direction: SortDirection.DESC,
          limit: MORE_FROM_LIMIT + 1,
          offset: 0,
        },
      },
    }
  );

  const articles = (data?.getArticleForStore.entities || [])
    .filter((article) => article.id !== currentArticleId)
    .slice(0, MORE_FROM_LIMIT);

  if (!articles.length) {
    return null;
  }

  return (
    <section className={styles.root} aria-labelledby="article-more-from">
      <h2 id="article-more-from" className={styles.title}>
        More from {storeName}
      </h2>
      <ul className={styles.list}>
        {articles.map((article) => (
          <li key={article.id}>
            <ContentCard
              type={ContentType.NEWS}
              imageUrl={article.url || ''}
              tzCode={null}
              linkUrl={`/${storeSlug}/news/${article.slug}`}
              dateTime={article.createdAt || ''}
              title={article.title || ''}
              user={storeName}
              userUrl={`/${storeSlug}`}
              isPlay={false}
              isArticleCard
            />
          </li>
        ))}
      </ul>
    </section>
  );
};

export default ArticleMoreFrom;
